module.exports = "./img/2d2e07ab25d52a44299e7a950be99da2.jpg";